import dayjs from 'dayjs';

export function parseTime(time: string | Date |  undefined, commonDateFormat = 'MM-DD-YYYY HH:mm:ss') {
   if(!time) return '';

    return dayjs(time).format(commonDateFormat);
}
